import { io } from "socket.io-client";

let socketInstance = null;

export const getSocket = () => socketInstance;

// Lee el token vigente de localStorage. Se usa como funcion (no valor fijo) en
// `auth` para que cada reconexion automatica de socket.io (tras un corte de red
// o inactividad) mande el token actual, no el que existia cuando se creo el
// socket por primera vez.
const getStoredToken = () =>
  (typeof localStorage !== "undefined" ? localStorage.getItem("token") : null);

export const initSocket = (token) => {
  const initialToken = token || getStoredToken();
  if (!initialToken) return null;
  const url = (process.env.REACT_APP_SOCKET_URL || process.env.REACT_APP_API_URL || "").replace(/\/+$/, "");
  if (!url) return null;
  if (socketInstance) return socketInstance;

  socketInstance = io(url, {
    transports: ["websocket"],
    auth: (cb) => cb({ token: getStoredToken() || initialToken }),
  });

  socketInstance.on("connect_error", (err) => {
    console.error("Error de socket:", err?.message || err);
  });

  return socketInstance;
};

export const disconnectSocket = () => {
  if (socketInstance) {
    socketInstance.disconnect();
    socketInstance = null;
  }
};
